<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull || !isLive"
    @refresh="onRefresh"
  >
    <div v-if="!isLive" class="pageNative flex_center">
      <div
        v-if="activityInfo.activityStatus === 0"
        class="nativeStatus flex_center"
      >
        活动将于 {{ activityInfo.startTime }} 开始
      </div>
      <div
        v-if="activityInfo.activityStatus === 2"
        class="nativeStatus flex_center"
      >
        活动已结束
      </div>
    </div>
    <div v-else class="page">
      <!-- 头图 -->
      <div
        class="page_header bg_contain"
        :style="{
          backgroundImage: `url(${activityInfo.banner})`,
        }"
      >
      </div>
      <div class="rule fs_12 flex_center bold" @click="onGoRulePage">活动规则</div>
      <div class="main">
        <div v-for="bk in blocks" :key="bk.activityGameId" class="block">
          <div class="body_bg"></div>
          <div class="game flex_center" @click="onClickDownload(bk)">
            <div
              class="game_icon bg_contain"
              :style="{ backgroundImage: `url(${bk.icon})` }"
            ></div>
            <div class="game_info">
              <div class="game_title fs_18 mb_4">{{ bk.gameName }}</div>
              <div class="game_tags fs_12 flex_center">
                <div v-for="tg in bk.tagV2s" :key="tg.tagId" class="game_tg">
                  
                  <!-- 边框文字 -->
                  <div  
                    v-if="tg.tagType === 1"
                    class="tag_1"
                    :style="{
                      borderColor: tg.labelInfo,
                      color: tg.labelInfo,
                    }"
                  >{{ tg.labelName }}</div>
                  <!-- 填充 -->
                  <div 
                    v-if="tg.tagType === 2"
                    class="tag_2"
                    :style="{
                      backgroundColor: tg.background,
                      color: tg.labelInfo,
                      borderColor: tg.background,
                    }"
                  >{{ tg.labelName }}</div>
                  <!-- 图片 -->
                  <div v-if="tg.tagType === 3" class="tag_3">
                    <img :src="tg.pictureTag" :alt="tg.labelName" />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="game_btn flex_center bold bg_contain fs_12"
              :style="{ backgroundImage: `url(${CDN_URL}/download.png)` }"
            >去下载</div>
          </div>
          <div class="block_divider"></div>
          <div class="welfares">
            <div
              v-for="wel in bk.rewardVos"
              :key="wel.activityGiftId"
              class="wel_item flex_center bg_contain"
              :style="{ backgroundImage: `url(${CDN_URL}/wel_bg.png)` }"
            >
              <div
                class="wel_icon bg_contain"
                :style="{ backgroundImage: `url(${wel.rewardIcon})` }"
              ></div>
              <div class="wel_info">
                <div class="wel_title mb_4">{{ wel.rewardName }}</div>
                <div class="wel_desc fs_12 van-multi-ellipsis--l2">{{ getWelContent(wel) }}</div>
              </div>
              <div class="wel_right">
                <div v-if="wel.drawStatus === 0" style="color: #000; background-color: #1DF3FF;" class="flex_center wel_btn" @click="onReceive(wel, bk)">领取</div>
                <div v-if="wel.drawStatus === 1" style="background-color: #aaa;" class="flex_center wel_btn">已领取</div>
                <div v-if="wel.drawStatus === 2" style="background-color: #aaa;" class="flex_center wel_btn">已过期</div>
                <div v-if="wel.drawStatus === 3" style="background-color: #311CCD;" class="flex_center wel_btn">历史创角</div>
                <div class="wel_condi">{{ getWelCondition(wel) }}</div>
              </div>
            </div>
          </div>
        </div>
        <Tips />
      </div>
      <ActivityPopup
        :visible.sync="visible"
        v-bind="feedback"
        :showProgress="[1, 2, 3].includes(feedbackType)"
        :progressAttrs="progressAttrs"
        :headerStyle="{background: '#0EA898'}"
        :innerTitleStyle="{color: '#0EA898'}"
        confirmButtonColor="#0EA898"
        @confirm="feedback.onSure"
      >
      </ActivityPopup>
    </div>
  </PullRefresh>
</template>

<script>
import {
  setPageTitle,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityPopup from "@/components/btBox/ActivityPopup";
import EventTrack from '@/mixins/eventTrack'
import LinkTo from '@/mixins/linkTo'
import { get328HomePage, get328Gift } from '@/apis/wxActivity'
import Tips from "@/views/box/328/tips.vue";
import { CDN_URL_1 } from "@/config";

const REWARD_TYPE_MAP = {
  1: { text: '积分' },
  2: { text: '代金券' },
  3: { text: '礼包' },
}

export default {
  components: {
    PullRefresh,
    ActivityPopup,
    Tips,
  },
  mixins: [EventTrack, LinkTo],
  data () {
    return {
      isWx: true,
      CDN_URL: 'https:' + CDN_URL_1 + '/328',
      activityInfo: {
        activityId: "",
        name: "",
        activityStatus: "",
        startTime: "",
        endTime: "",
      },
      disabledPull: false,
      visible: false,
      feedbackType: 0,
      hasFetched: false,
      isLoading: false,
      progressAttrs: {
        currentVal: 0,
        targetVal: 100,
        skins: {
          color: '#0F887B',
          background: 'linear-gradient(90deg,#0ea898 0%, #65e0d3 100%)',
          borderColor: '#0F887B',
        },
      },
      curWel: {},
      blockInfo: {},
    }
  },
  computed: {
    actId () {
      return this.$route.query.id || 1
    },
    isLive () {
      if (!this.hasFetched) return true
      if (!this.activityInfo.activityId && this.hasFetched) return false
      return this.activityInfo.activityStatus === 1
    },
    blocks () {
      return this.activityInfo.generalRegActivityGameVos || []
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      const { condite, drawCondite, rewardContent, rewardName } = this.curWel
      const { x, y } = JSON.parse(condite || '{}') 
      return [
        {
          title: '不满足领取条件',
          message: [
            '未查询到游戏记录',
            '在活动时间内下载游戏并用此账号创角',
            '即可领取该礼包'
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            this.onCompleteBtn()
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `创角${x}天充值${y}笔`
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            this.onCompleteBtn()
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `创角${x}天累计登录游戏${y}天`
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            this.onCompleteBtn()
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `创角${x}天累计付费${y}元`,
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            this.onCompleteBtn()
          }
        },
        {
          title: '恭喜您获得',
          innerTitle: rewardName,
          message: [
            '积分已下发至您的账户内'
          ],
          confirmButtonText: '去使用积分',
          onSure: () => {
            this.onSureSuccess(1)
            this.triggerVisible(false)
            this.handleGoPointsMall()
          }
        },
        {
          title: '恭喜您获得',
          innerTitle: rewardName,
          message: [
            '代金券已存放在',
            '【我的】-【代金券】'
          ],
          confirmButtonText: '查看代金券',
          onSure: () => {
            this.onSureSuccess(2)
            this.triggerVisible(false)
            this.handleGoVoucher()
          }
        },
        {
          title: '恭喜您获得',
          innerTitle: rewardName,
          message: [
            '礼包码已存放在',
            '【我的】-【我的礼包】-【活动礼包】'
          ],
          confirmButtonText: '查看礼包',
          onSure: () => {
            this.onSureSuccess(3)
            this.triggerVisible(false)
            this.handleGoGift()
          }
        },
        {
          title: '提示',
          message: [
            '代金券领取错误',
            '请联系客服'
          ],
          confirmButtonText: '联系客服',
          onSure: () => {
            this.onSureSuccess(4)
            this.triggerVisible(false)
            this.onRelationServer()
          },
        },
        {
          title: '提示',
          message: [
            '兑换码生成错误',
            '请联系客服领取备用码'
          ],
          confirmButtonText: '联系客服',
          onSure: () => {
            this.onSureSuccess(5)
            this.triggerVisible(false)
            this.onRelationServer()
          },
        },
      ]
    },
  },
  mounted () {
    // 如果浏览器没有调用接口，可以加上 IS_DEV 的 query 参数
    const { query } = this.$route
    if (query.IS_DEV) {
      this.init()
    }
    this.getAppToken(true)
  },
  activated () {
    setPageTitle(this.activityInfo.name)
  },
  methods: {
    init () {
      return this.getActInfo().then(res => {
        this.eventTrack({
          event: "general_reg_activity_home",
          event_field: this.getTrackInfo(),
        })
        setPageTitle(this.activityInfo.name)
      })
    },
    getActivityInfo () {
      this.init()
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 300)
      })
    },
    getActInfo () {
      return get328HomePage({
        activityId: this.actId,
      }).then(res => {
        this.activityInfo = res.data || {
          activityId: '',
          startTime: "",
          activityStatus: 2,
          generalRegActivityGameVos: [],
        }
      }).finally(() => this.hasFetched = true)
    },
    onReceive (wel = {}, block = {}) {
      this.curWel = wel
      this.blockInfo = block
      const { 
        rewardType, drawStatus, drawCondite, activityGiftId,
        rewardContent, rewardName, rewardValue,
      } = wel
      if (drawStatus !== 0) return
      if (this.receiveLoading) return
      this.receiveLoading = true
      const { gameId, gameName } = block
      this.eventTrack({
        event: "general_reg_activity_reward_draw_button",
        event_field: this.getTrackInfo({
          reward_name: rewardName,
          reward_value: rewardValue,
          reward_type: rewardType,
          draw_condite: drawCondite
        }),
        appkey: gameId,
        appName: gameName,
      })
      get328Gift({
        activityGiftId
      }).then(res => {
        const { cdk, result } = res.data
        let isSuccess = false
        if (rewardType === 1) {
          this.triggerVisible(true, 4)
          isSuccess = true
        }
        if (rewardType === 2) {
          this.triggerVisible(true, result ? 5 : 7)
          isSuccess = !!result
        }
        if (rewardType === 3) {
          this.triggerVisible(true, cdk ? 6 : 8)
          isSuccess = !!cdk
        }
        this.getActInfo()
        this.eventTrack({
          event: "general_reg_activity_draw_result_pop",
          event_field: this.getTrackInfo({
            reward_name: rewardName,
            reward_value: rewardValue,
            reward_type: rewardType,
            draw_condite: drawCondite,
            type: isSuccess ? 1 : 2
          }),
          appkey: gameId,
          appName: gameName,
        })
      }).catch(err => {
        const { code, msg } = err
        // 95400 - 不满足领取条件-未查询到游戏记录
        // 95401 - 不满足领取条件-创角X 天内充值Y 笔即可领取礼包 当前值/目标值
        // 95402 - 不满足领取条件-创角X 天内累计登录X天即可领取礼包 当前值/目标值
        // 95403 - 不满足领取条件-创角X 天内充值金额达到Y元即可领取礼包 当前值/目标值
        const errorCodes = [95400, 95401, 95402, 95403]
        if (errorCodes.includes(code)) {
          const i = errorCodes.indexOf(code)
          this.triggerVisible(true, i)
          if (code !== 95400) {
            const [a, b] = msg.split('/')
            this.progressAttrs.currentVal = a * 1
            this.progressAttrs.targetVal = b * 1
          }
          this.eventTrack({
            event: "general_reg_activity_not_complete_pop",
            event_field: this.getTrackInfo({
              reward_name: rewardName,
              reward_value: rewardValue,
              reward_type: rewardType,
              draw_condite: drawCondite,
              cur_value: code !== 95400 ? this.progressAttrs.currentVal * 1 : null,
              tar_value: code !== 95400 ? this.progressAttrs.targetVal * 1 : null,
            }),
            appkey: gameId,
            appName: gameName,
          })
        } else {
          // 已领取过同类奖励
          if (code === 1600) {
            this.getActInfo()
          }
          this.$toast.fail(msg)
        }
      }).finally(() => {
        this.receiveLoading = false
      })
    },
    triggerVisible (visible, type) {
      if (visible && this.visible) return
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
    },
    onClickDownload (bk) {
      const { gameId, gameName } = bk
      this.eventTrack({
        event: "general_reg_activity_game_info",
        event_field: this.getTrackInfo(),
        appkey: gameId,
        appName: gameName,
      })
      this.onGoDownload(gameId)
    },
    onGoDownload (gameId) {
      this.handleGoDownload(gameId, 63)
    },
    onGoRulePage () {
      this.eventTrack({
        event: "general_reg_activity_home_rule",
        event_field: this.getTrackInfo(),
      })
      this.handleGoRulePage(27)
    },
    // 奖励内容文案
    getWelContent (wel) {
      const { rewardContent } = wel
      return `${rewardContent}`
    },
    // 奖励条件文案
    getWelCondition (wel) {
      const { drawCondite, condite } = wel
      if ([1].includes(drawCondite)) return '游戏内创角'
      const { x, y } = JSON.parse(condite || '{}')
      const condiMap = {
        2: `创角${x}天充值${y}笔`,
        3: `创角${x}天累计登录游戏${y}天`,
        4: `创角${x}天累计付费${y}元`,
      }
      return condiMap[drawCondite]
    },
    getTrackInfo (params = {}) {
      return JSON.stringify({
        activity_id: this.activityInfo.activityId,
        activity_name: this.activityInfo.name,
        ...params,
      })
    },
    // 去完成按钮
    onCompleteBtn () {
      const { gameId, gameName } = this.blockInfo
      const { rewardName, rewardValue, drawCondite, rewardType } = this.curWel
      this.eventTrack({
        event: "general_reg_activity_to_complete",
        event_field: this.getTrackInfo({
          reward_name: rewardName,
          reward_value: rewardValue,
          reward_type: rewardType,
          draw_condite: drawCondite,
          cur_value: this.progressAttrs.currentVal * 1,
          tar_value: this.progressAttrs.targetVal * 1,
        }),
        appkey: gameId,
        appName: gameName,
      })
      this.triggerVisible(false)
      this.onGoDownload(gameId)
    },
    // 领取成功的确定按钮
    onSureSuccess (type) {
      const { rewardName, rewardValue, drawCondite, rewardType } = this.curWel
      this.eventTrack({
        event: "general_reg_activity_draw_result_button",
        event_field: this.getTrackInfo({
          reward_name: rewardName,
          reward_value: rewardValue,
          reward_type: rewardType,
          draw_condite: drawCondite,
          type,
        }),
      })
    },
  },
}
</script>

<style scoped lang="scss">
.page, .pageNative {
  position: relative;
  min-height: 100vh;
  background-color: #010101;
  transition: 0.2s all ease;
  color: #fff;
}

.page {
  padding-top: 196px;
  padding-bottom: 24px;
  position: relative;
}

.page_header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 214px;
}
.main {
  position: relative;
  padding: 8px 8px;
}

.rule {
  position: absolute;
  right: 0;
  padding: 4px 8px 4px 10px;
  top: 16px;
  color: black;
  border-top-left-radius: 1000px;
  border-bottom-left-radius: 1000px;
  background: #E5F050;
  transform: translateX(1px);
  transform-origin: 100% 0%;
}

.game {
  position: relative;
  z-index: 2;
  .game_icon {
    width: 60px;
    height: 60px;
    margin-right: 12px;
    border-radius: 4px;
  }
  .game_title {
    color: #ABFFF2;
  }
  .game_info {
    flex: 1;
    width: 0;
  }
  .game_tags {
    flex-wrap: wrap;
    justify-content: start;
  }
  .game_tg {
    display: flex;
    align-items: center;
    height: 15px;
    margin-top: 4px;
    margin-right: 3px;
  }
  .game_btn {
    width: 78px;
    height: 28px;
  }
}

.tag_1, .tag_2 {
  font-size: 10px;
  padding: 1px 2px;
  line-height: 11px;
  border-radius: 2px;
  border: 1px solid #fff;
}

.tag_3 {
  img {
    height: 15px;
  }
}

.block {
  position: relative;
  padding: 24px 18px 16px;
  margin-bottom: 12px;
}

.block::before,
.block::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 50px; /* 顶部和底部图片的高度 */
  left: 0;
  // z-index: -1;
}

.block::before {
  top: 0;
  background-image: url('https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/328/block_top.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
}

.block::after {
  bottom: 0;
  background-image: url("https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/328/block_bot.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom center;
}

.block_divider {
  position: relative;
  z-index: 2;
  width: calc(100% - 12px);
  height: 2px;
  margin: 12px 6px 8px 6px;
  background: linear-gradient(90deg, #21eef91f 0%, #21eef9 30%, #21eef9 70%, #21eef91f 100%);
}

.body_bg {
  position: absolute;
  z-index: 1;
  left: 0px;
  top: 50px;
  width: 100%;
  height: calc(100% - 100px);
  // height: 100px;
  background-image: url("https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/328/block_mid.png");
  background-size: 100% 100%;
}

.welfares {
  position: relative;
  z-index: 2;
  .wel_item {
    padding: 16px 6px 16px 16px;

    background-size: 100% 100%;
  }
  .wel_item + .wel_item {
    margin-top: 8px;
  }
  .wel_icon {
    width: 42px;
    height: 42px;
    margin-right: 6px;
  }
  .wel_info {
    width: 0;
    flex: 1;
    .wel_title {
      color: #FDFF79;
      font-size: 15px;
    }
    .wel_desc {
      line-height: 14px;
    }
  }
  .wel_right {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 88px;
    .wel_btn {
      width: 64px;
      height: 22.5px;
      color: #fff;
      font-size: 12px;
      border-radius: 20px;
    }
    .wel_condi {
      margin-top: 4px;
      font-size: 10px;
      text-align: center;
      color: #FDFF79;
      white-space: pre-wrap;
    }
  }
}
.popup_unique_mark {
  color: #000;
}
</style>